export interface Testimonial {
    /** Stable key, also used for the :key in the grid. */
    id: string;
    name: string;
    company: string;
    /** Portrait in public/images/persons/. Empty falls back to a monogram avatar. */
    image: string;
    /**
     * Draft entries only render on the dev server, so unfinished placeholders
     * never reach production. Fill in the copy, then flip this to false.
     */
    draft?: boolean;
    nl: { quote: string; role: string };
    en: { quote: string; role: string };
}

export const testimonials: Testimonial[] = [
    {
        id: 'food-la-route',
        name: 'Renée Turion',
        company: 'Food la Route',
        image: '',
        nl: {
            role: 'Eigenaar',
            quote:
                'BitPeak heeft Food la Route volledig geautomatiseerd. Van boekingen en communicatie tot facturatie en afhandeling: alles loopt nu centraal en efficiënt. Dat geeft ons rust, overzicht en ruimte om te focussen op groei.',
        },
        en: {
            role: 'Founder',
            quote:
                'BitPeak fully automated the Food la Route platform. From bookings and communication to invoicing and operations, everything now runs centrally and efficiently. It gives us clarity, peace of mind, and the freedom to focus on growth.',
        },
    },
    {
        id: 'client-2',
        draft: true,
        name: '[PLACEHOLDER: naam klant 2]',
        company: '[PLACEHOLDER: bedrijf klant 2]',
        image: '',
        nl: {
            role: '[PLACEHOLDER: functie]',
            quote: '[PLACEHOLDER: quote klant 2: 2 tot 4 regels, bij voorkeur met een concreet resultaat]',
        },
        en: {
            role: '[PLACEHOLDER: role]',
            quote: '[PLACEHOLDER: quote client 2: 2 to 4 lines, ideally naming a concrete result]',
        },
    },
    {
        id: 'client-3',
        draft: true,
        name: '[PLACEHOLDER: naam klant 3]',
        company: '[PLACEHOLDER: bedrijf klant 3]',
        image: '',
        nl: {
            role: '[PLACEHOLDER: functie]',
            quote: '[PLACEHOLDER: quote klant 3: 2 tot 4 regels, bij voorkeur met een concreet resultaat]',
        },
        en: {
            role: '[PLACEHOLDER: role]',
            quote: '[PLACEHOLDER: quote client 3: 2 to 4 lines, ideally naming a concrete result]',
        },
    },
];
